import { render } from "./ClassView.vue?vue&type=template&id=f877c77e&scoped=true"
import script from "./ClassView.vue?vue&type=script&lang=js"
export * from "./ClassView.vue?vue&type=script&lang=js"

import "./ClassView.vue?vue&type=style&index=0&id=f877c77e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f877c77e"]])

export default __exports__